module.exports = __webpack_public_path__ + "img/empty.8f5c2301.png";